import { MChapter } from './chapter.model';
import { Subversion } from '../interfaces/Organization';

export class MSubversion{
    public chapters: MChapter[];
    public updateDate: string;
    public id: number;
    public url: string;

    constructor(sub: Subversion){
        if (sub.capitulos) {
            this.chapters = [];
            for (let i = 0; i < sub.capitulos.length; i++) {
                this.chapters.push(new MChapter(sub.capitulos[i]))          
            }
        }
        if (sub.fecha_actualizacion) {
            this.updateDate = sub.fecha_actualizacion; 
        }
        if (sub.id) {
            this.id = sub.id;
        }
        if (sub.url) {
            this.url = sub.url
        }
    }
}